export const ds_EmbedBlock_Entry = `
    fragment ds_EmbedBlock_Entry on ds_EmbedBlock_Entry {
        id
        canonicalUid
        embed_Code
        embed_ContainerWidth
        embed_TopSpacing
    }
`